var map = {
	"./bg_aibiz.png": "6693",
	"./bg_cybersafe.png": "8a42",
	"./bg_dsbiz.png": "04d1",
	"./bg_greenSkils.png": "7e30",
	"./bg_iot.png": "de07",
	"./bg_spark.png": "69a3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3f52";